module.exports = {
  // 数据查询
  dataList: {
    'click_match': {
      'title': '点击匹配异常',
      'map': {
        'platform': {
          'name': '平台'
        },
        'main_game_id': {
          'name': '主ID'
        },
        'main_game_name': {
          'name': '主游戏'
        },
        'search_percent': {
          'name': '匹配率',
          'type': 'percent'
        },
        'reg_count': {
          'name': '注册数'
        }
      }
    },
    'root_game_tag': {
      'title': '游戏漏打标签',
      'map': {
        'platform': {
          'name': '平台'
        },
        'root_game_id': {
          'name': '根ID'
        },
        'root_game_name': {
          'name': '根游戏'
        },
        'reg_num': {
          'name': '注册数'
        }
      }
    },
    'agent_group_muid_ratio': {
      'title': '设备获取异常(按渠道)',
      'map': {
        'platform': {
          'name': '平台'
        },
        'agent_group_name': {
          'name': '渠道组'
        },
        'os': {
          'name': '系统'
        },
        'click_count': {
          'name': '点击数'
        },
        'click_muid_ratio': {
          'name': '点击设备比例',
          'type': 'percent'
        },
        'device_count': {
          'name': '激活数'
        },
        'device_muid_ratio': {
          'name': '激活设备比例',
          'type': 'percent'
        },
        'reg_count': {
          'name': '注册数'
        },
        'reg_muid_ratio': {
          'name': '注册设备比例',
          'type': 'percent'
        }
      }
    },
    'payment_alert': {
      'title': '首日回本预警',
      'map': {
        'game_reg_date': {
          'name': '日期'
        },
        'agent_leader': {
          'name': '渠道负责人'
        },
        'platform': {
          'name': '平台'
        },
        'plat_name': {
          'name': '游戏类型'
        },
        'root_game_name': {
          'name': '根游戏'
        },
        'main_game_name': {
          'name': '主游戏'
        },
        'game_name': {
          'name': '子游戏'
        },
        'agent_group_name': {
          'name': '渠道组'
        },
        'agent_id': {
          'name': '渠道ID'
        },
        'agent_name': {
          'name': '渠道'
        },
        'day_reg_uid_count': {
          'name': '注册数'
        },
        'day_cost_money': {
          'name': '消耗'
        },
        'first_day_roi': {
          'name': '首日回本率'
        },
        'first_standard_value': {
          'name': '首日回本标准'
        },
        'diff': {
          'name': '差异'
        }
      }
    },
    'new_server_warming': {
      'title': '新服量级预警',
      'map': {
        'platform': {
          'name': '平台'
        },
        'root_game_id': {
          'name': '根游戏ID'
        },
        'root_game_name': {
          'name': '根游戏'
        },
        'main_game_id': {
          'name': '主游戏ID'
        },
        'main_game_name': {
          'name': '主游戏'
        },
        'ori_server_id': {
          'name': '区服ID'
        },
        'role_num': {
          'name': '预警值'
        },
        'open_time': {
          'name': '开服时间'
        }
      }
    },
    'true_name_warning': {
      'title': '账号实名率预警',
      'map': {
        'platform': {
          'name': '平台'
        },
        'root_game_id': {
          'name': '根游戏ID'
        },
        'root_game_name': {
          'name': '根游戏'
        },
        'main_game_id': {
          'name': '主游戏ID'
        },
        'main_game_name': {
          'name': '主游戏'
        },
        'game_id': {
          'name': '子游戏ID'
        },
        'game_name': {
          'name': '子游戏'
        },
        'uid_count': {
          'name': '注册数'
        },
        'true_rate': {
          'name': '实名率'
        },
        'start_time': {
          'name': '起始时间'
        },
        'end_time': {
          'name': '结束时间'
        }
      }
    }
  }
}
